<template>
  <div data-component-group="label-dialog" data-component="edit">
    <dialog-edit
      :title="activeLabel.name"
      icon="label"
      :copy-link="`/labels/${activeLabel?.id}`"
      content-class="edit-label-dialog"
      is-fullscreen
      :is-on="true"
      :on-close="onCancel"
    >
      <template v-slot:content>
        <forms-label-edit
          :label="activeLabel"
          :is-loading="isEditingLabel"
          :on-cancel="onCancel"
          :on-submit="canUpdateLabel ? updateLabel : undefined"
        />
      </template>
    </dialog-edit>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import type { LabelListItem } from '@/types';
  import type { LabelPayload } from '@/api/merchy/labels';

  export default defineComponent({
    emits: ['saved'],
    data() {
      return {
        isEditingLabel: false,
      };
    },
    created() {
      if (!this.activeLabel?.id) {
        this.$store.dispatch('labels/getItem', { id: this.$route.params.id });
      }
    },
    computed: {
      activeLabel(): Partial<LabelListItem> {
        return this.$store.getters['labels/activeItem'];
      },
      canUpdateLabel() {
        return this.$store.getters['auth/isAuthorized']([{ subject: 'label', actions: ['update'] }]);
      },
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'labels', query: this.$route.query });
      },
      updateLabel(label: LabelPayload) {
        if (!this.canUpdateLabel) {
          return undefined;
        }

        const nextLabel = {
          ...label,
          id: this.activeLabel.id,
        };

        this.isEditingLabel = true;

        return this.$store
          .dispatch('labels/update', nextLabel)
          .then((res) => {
            this.$emit('saved');
            this.$router.push({ name: 'labels', query: this.$route.query });
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isEditingLabel = false;
          });
      },
    },
  });
</script>
